<template>
  <div class="channel-header header-c-nav">
    <ul class="nav-ul">
      <li
        v-for="({ name, url, list, showH1, ...otherItem }, i) in navList"
        :key="name + i"
        :class="setMoreClass(name, url)"
        @click="!url && name === '更多' && handleMore(list)"
      >
        <div v-if="!url && name === '更多'" class="one-line more-name">
          {{ name }}
        </div>
        <template v-else>
          <h1 v-if="showH1">
            <a class="one-line" :href="url" target="_blank">{{ name }}</a>
          </h1>
          <a v-else class="one-line" :href="url" target="_blank">{{ name }}</a>
        </template>
        <img
          v-if="!url && name === '更多'"
          src="//i0cloud.jrjimg.cn/cloud/images/common/arrow-o.png"
          alt="更多"
        />
      </li>
    </ul>
    <div class="channel-more-box">
      <ul v-if="showMore">
        <li
          v-for="({ name, url, showH1, ...otherItem }, i) in moreList"
          :key="name + i"
          :style="setMoreStyle(name, url, otherItem)"
        >
          <h1 v-if="showH1">
            <a :href="url" target="_blank">{{ name }}</a>
          </h1>
          <a v-else :href="url" target="_blank">{{ name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { queryPartApi } from 'api/common'
export default {
  props: {
    path: {
      type: String,
      default: '/quotation/hsMarket'
    },
    baseUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showMore: false,
      navList: [],
      moreList: []
    }
  },
  created() {
    queryPartApi({ channelNum: '999', infoCls: '002015' }).then((res) => {
      this.navList = res.data.data
    })
  },
  methods: {
    // 更多样式
    setMoreStyle(name, url, otherItem) {
      let style = {}
      if (otherItem?.width) {
        style.width = otherItem.width
      }
      return style
    },
    // 更多样式
    setMoreClass(name, url) {
      let className = ''
      // 更多
      if (!url && name === '更多') {
        className = 'channel-more'
        if (this.showMore) {
          className += ' arrows-t'
        }
      }
      return className
    },
    // 点击更多
    handleMore(list) {
      this.showMore = !this.showMore
      this.moreList = list
    }
  }
}
</script>
<style lang="scss" scoped>
.channel-header {
  background-color: $color-theme;
  width: 1100px;
  height: 40px;
  margin: 0 auto;
  box-sizing: border-box;
}
.header-c-nav {
  background: $color-theme;
  height: 40px;
  margin-top: 12px;
  position: relative;
  ul.nav-ul {
    overflow: hidden;
    display: flex;
    li {
      flex: 1;
      float: left;
      font-size: 18px;
      line-height: 40px;
      cursor: pointer;
      width: auto;
      text-align: center;
      box-sizing: border-box;
      .item-name {
        display: inline-block;
      }
      a,
      .more-name {
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 10px;
          height: 10px;
          margin-left: 2px;
        }
        &:hover {
          text-decoration: underline;
        }
      }
      &.cur {
        a {
          background: #96001e;
        }
      }
      &.channel-more {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        img {
          width: 40px;
          height: 40px;
        }
      }
      &.channel-more.arrows-t {
        img {
          transform: rotate(180deg);
        }
      }
    }
  }
  .channel-more-box {
    position: absolute;
    top: 54px;
    right: 0;
    width: 217px;
    z-index: 11;
    background: url('//i0cloud.jrjimg.cn/cloud/images/common/menu-more.png')
      no-repeat;
    background-size: 100% 100%;
    ul {
      overflow: hidden;
      padding: 24px 0 0 16px;
      li {
        float: left;
        font-size: 17px;
        cursor: pointer;
        padding-right: 16px;
        padding-bottom: 19px;
        width: 67px;
        a {
          color: #595757;
          &:hover {
            color: $color-theme;
            text-decoration: underline;
          }
        }
        &.cur {
          a {
            color: $color-theme;
          }
        }
      }
    }
  }
}
</style>
